var radio = require('ES/lib/radio');

module.exports = function(){
	radio('invalidate_Displaylists_cache').broadcast();
	radio('Displaylists_get').broadcast({clear_cache: true});
};



// WEBPACK FOOTER //
// ./src/utils/reloadDisplaylists.js